<template>
  <div class="modal--filters">
    <div class="modalCustom__header">
      <div class="flex justify-content-between">
        <h5 class="">{{ data.header }}</h5>
        <h5 class="times" @click="closeModal">&times;</h5>
      </div>
      <hr class="modalCustom__header-border" />
    </div>

    <div class="modalCustom__body">
      <!--           Content-->
      <h5>Score</h5>

      <div v-if="checkIfCanSeeDoneQuestions()" class="form__radio-group">
        <fg-input
          type="radio"
          label="Done"
          :selected="defineIfSelectedForScoreFilters('Done')"
          @checked="checkedForScoreFilters('Done', $event)"
        >
        </fg-input>
      </div>

      <div class="form__radio-group">
        <fg-input
          type="radio"
          label="In Progress"
          :selected="defineIfSelectedForScoreFilters('In Progress')"
          @checked="checkedForScoreFilters('In Progress', $event)"
        >
        </fg-input>
      </div>
      <div class="form__radio-group">
        <fg-input
          type="radio"
          id
          label="Open"
          :selected="defineIfSelectedForScoreFilters('Open')"
          @checked="checkedForScoreFilters('Open', $event)"
        >
        </fg-input>
      </div>
      <div class="form__radio-group">
        <fg-input
          type="radio"
          label="Not Answered"
          :selected="defineIfSelectedForScoreFilters('Not Answered')"
          @checked="checkedForScoreFilters('Not Answered', $event)"
        >
        </fg-input>
      </div>
      <div class="form__radio-group mt-3">
        <fg-input
          type="radio"
          label="Sort by Impact"
          :selected="defineIfSelectedForScoreFilters('By Impact')"
          @checked="checkedForScoreFilters('By Impact', $event)"
        >
        </fg-input>
      </div>

      <div v-for="(filterOptions, label) in filters" v-bind:key="label" class="row">
        <div class="w-auto" v-if="label === 'Categories'">
          <h5>{{ label }}</h5>
          <div
            v-for="(filterOption, index) in filterOptions"
            v-bind:key="index"
            class="form__radio-group u-margin-bottom-small"
          >
            <fg-input
              type="radio"
              :label="filterOption.name"
              :selected="defineIfSelected(filterOption)"
              @checked="checked(filterOption, label, $event)"
            >
            </fg-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import checkIfCanSeeQuestionnaire from '@/router/scopes/questionnaire/CheckIfCanSeeQuestionnaire';

export default {
  name: 'FiltersModal',
  props: {
    data: {
      type: Object,
      header: {
        type: String,
      },
      filtersOptions: {
        type: Object,
      },
      checkedFilters: {
        type: Array,
      },
    },
  },
  data() {
    return {
      filters: null,
      selectedFilters: [],
    };
  },
  mounted() {
    this.setFilters();
  },
  methods: {
    setFilters() {
      this.filters = this.data.filtersOptions;
    },
    closeModal: function () {
      this.$emit('close');
    },
    checked(filterOption, label, checked) {
      this.selectedFilters = this.data.checkedFilters;
      if (checked) this.selectedFilters.push(filterOption);
      else {
        let foundIndex = this.selectedFilters.findIndex((selectedFilter) => {
          return selectedFilter.id === filterOption.id;
        });
        this.selectedFilters.splice(foundIndex, 1);
      }
      this.$emit('submit', this.selectedFilters);
    },
    checkedForScoreFilters(filterOption, checked) {
      this.selectedFilters = this.data.checkedFilters;
      if (checked) {
        this.selectedFilters = this.selectedFilters.filter(function (filter) {
          return filter.name;
        });
        this.selectedFilters.push(filterOption);
      } else {
        let foundIndex = this.selectedFilters.findIndex((selectedFilter) => {
          return selectedFilter === filterOption;
        });
        this.selectedFilters.splice(foundIndex, 1);
      }
      this.$emit('submit', this.selectedFilters);
    },
    defineIfSelected(filterOption) {
      if (this.data.checkedFilters.length > 0) {
        return this.data.checkedFilters.some((checkedFilter) => {
          return checkedFilter.id === filterOption.id;
        });
      }
    },
    defineIfSelectedForScoreFilters(filterOption) {
      if (this.data.checkedFilters.length > 0) {
        return this.data.checkedFilters.some((checkedFilter) => {
          return checkedFilter === filterOption;
        });
      }
    },
    checkIfCanSeeDoneQuestions() {
      return checkIfCanSeeQuestionnaire();
    },
  },
};
</script>

<style scoped>
.times {
  cursor: pointer;
  font-size: 2rem;
}
</style>
